import React from "react";
import { makeStyles, createStyles, Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import Header from "./OptionOneSections/Header";
import HomeValueSteps from "./OptionOneSections/HomeValueSteps";
import ImageGraphic from "./OptionOneSections/ImageGraphic";
import SearchBar from "./OptionOneSections/SearchBar";
import LandingFooter from "./LandingFooter";

const useStyles = makeStyles((theme) => createStyles({}));

const OptionOne = ({ canCreate, userData, setCreateReportOpen, setNoReport }) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.landingPageContainer}>
      <Grid item xs={12}>
        <Header userData={userData} />
      </Grid>
      <Grid item xs={12}>
        <SearchBar setNoReport={setNoReport} canCreate={canCreate} userData={userData} setCreateReportOpen={setCreateReportOpen} />
      </Grid>
      <Grid item xs={12}>
        <ImageGraphic userData={userData} />
      </Grid>
      <Grid item xs={12}>
        <HomeValueSteps userData={userData} />
      </Grid>
      <Grid item xs={12}>
        <LandingFooter userData={userData} />
      </Grid>
    </Grid>
  );
};
OptionOne.propTypes = {
  userData: PropTypes.object,
  setCreateReportOpen: PropTypes.func,
  setNoReport: PropTypes.func,
  canCreate: PropTypes.bool,
};

export default OptionOne;
